import taskGray from '../../../../assets/svg/Icons/16/task-gray.svg';
import taskGreen from '../../../../assets/svg/Icons/16/task-green.svg';

import taskInstanceListItemUrl from './taskInstanceListItem.html';

class TaskInstanceListItemCtrl {
  constructor(PersonaCollection, Utils, sdk, $state) {
    'ngInject';

    Object.assign(this, { PersonaCollection, $state });
    Utils.extendWithProps(sdk('constants'), this, ['TASK_INSTANCE_COMPLETED_STATUS']);
  }

  $onInit() {
    this.setMetricsAndIcons();
  }

  $onChanges({ instance, rebuildCounter }) {
    if (instance && !instance.isFirstChange()) {
      this.setMetricsAndIcons();
    } else if (rebuildCounter && !rebuildCounter.isFirstChange()) {
      this.setMetricsAndIcons();
    }
  }

  getSubtasksMetrics() {
    const { subtasks } = this.instance;
    if (subtasks?.length) {
      const subtaskCount = subtasks.length;
      const completedCount = subtasks.filter(
        (subtask) => subtask.status === this.TASK_INSTANCE_COMPLETED_STATUS
      ).length;
      return {
        subtasksCounter: `${completedCount} / ${subtaskCount}`,
        areAllSubtasksCompleted: completedCount === subtaskCount,
      };
    }
    return {
      subtasksCounter: '',
      areAllSubtasksCompleted: false,
    };
  }

  setMetricsAndIcons() {
    const { subtasksCounter, areAllSubtasksCompleted } = this.getSubtasksMetrics();
    this.subtasksCounter = subtasksCounter;
    this.areAllSubtasksCompleted = areAllSubtasksCompleted;
    this.subtasksIcon = areAllSubtasksCompleted ? taskGreen : taskGray;
  }

  get assigneeName() {
    if (!this.instance.assigneeId) {
      return '';
    }
    return this.PersonaCollection.personasDict[this.instance.assigneeId]?.fullname;
  }

  get wasPrevItemPublished() {
    return this.prev?.isPublished;
  }

  get positionColor() {
    return this.PersonaCollection.personasDict[this.instance.positionId]?.color;
  }

  get positionName() {
    return this.PersonaCollection.personasDict[this.instance.positionId]?.name;
  }

  get locationName() {
    return this.PersonaCollection.personasDict[this.instance.locationId]?.name;
  }

  isCompleted(taskInstance) {
    return taskInstance.status === this.TASK_INSTANCE_COMPLETED_STATUS;
  }

  viewTask() {
    this.$state.go('shiftTasks.instances.view', { taskInstanceId: this.instance.id });
  }
}

export default {
  templateUrl: taskInstanceListItemUrl,
  controller: TaskInstanceListItemCtrl,
  controllerAs: 'ctrl',
  bindings: {
    instance: '<',
    isFirst: '<',
    prev: '<',
    rebuildCounter: '<',
  },
};
